import { Checkbox, Typography } from "@mui/material";

import { HighlightedDetailField } from "../../../components";
import { useStationListWithCache } from "../../../components/StationHookFormSelect";
import { useMaterialListWithCache } from "../../../components/HubMaterialHookSelect/useMaterialListWithCache";

import {
  FieldGrid,
  TableBodyRow,
  TableHeaderRow,
  TableShell,
} from "../styles";
import { BilingualTitle, Section, SectionSubHeader } from "../components";

const checkboxProps = { disabled: true, sx: { padding: 0 } };
const DIP_COLS = "60px 90px 1.5fr 1.5fr 1fr";

export const PartDipDetails = ({ section = {} }) => {
  const config = section?.config || {};
  const routing = section?.routing || [];

  const { materials: cached } = useMaterialListWithCache();
  const materials = Array.isArray(cached) ? cached : cached?.materials || [];
  const { stations = [] } = useStationListWithCache();

  return (
    <Section icon="Droplet" label="Dip Department" spanishLabel="Recubrimiento">
      <SectionSubHeader label="Dip Recipe" spanishLabel="Receta de Recubrimiento" />
      <TableShell>
        <TableHeaderRow columns={DIP_COLS}>
          <BilingualTitle label="#" spanishLabel="#" size="sm" />
          <BilingualTitle label="Prewet" spanishLabel="Prehumedecido" size="sm" />
          <BilingualTitle label="Material" spanishLabel="Material" size="sm" />
          <BilingualTitle label="Station" spanishLabel="Estación" size="sm" />
          <BilingualTitle label="Notes" spanishLabel="Notas" size="sm" />
        </TableHeaderRow>
        {routing.map((row, idx) => {
          const cfg = row?.config || {};
          const material = cfg?.materialId
            ? materials.find((m) => m.id === cfg.materialId)
            : null;
          const station = row?.stationId
            ? stations.find((s) => s.id === row.stationId)
            : null;
          return (
            <TableBodyRow key={row.id ?? idx} columns={DIP_COLS}>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                {idx + 1}.
              </Typography>
              <Checkbox checked={!!cfg?.prewet} {...checkboxProps} />
              <Typography variant="caption">
                {material?.name ?? material?.label ?? "—"}
              </Typography>
              <Typography variant="caption">{station?.label ?? "—"}</Typography>
              <Typography variant="caption">{row?.notes || "—"}</Typography>
            </TableBodyRow>
          );
        })}
      </TableShell>

      <SectionSubHeader
        label="Dip Summary"
        spanishLabel="Resumen del Recubrimiento"
      />
      <FieldGrid columns={1}>
        <HighlightedDetailField
          label="Final Dip Weight"
          spanishLabel="Peso Final del Recubrimiento"
          value={config?.weight}
        />
      </FieldGrid>

      <SectionSubHeader label="Notes" spanishLabel="Notas" />
      <HighlightedDetailField
        label="Notes"
        spanishLabel="Notas"
        value={section?.notes}
      />
    </Section>
  );
};

export default PartDipDetails;
